(() => {
  if (window.MahveenPricesLoaded) return;
  window.MahveenPricesLoaded = true;
  const normalize = () => {
    document.querySelectorAll('.money, .price, .cart__total-price, .cart-draw__total-price').forEach((element) => {
      if (!/(?:Rs\.?|PKR)/i.test(element.textContent)) return;
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const value = node.nodeValue.replace(/(\d)\.00(?=\s|$)/g, '$1');
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    });
  };
  const boot = () => {
    normalize();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; normalize(); });
    }).observe(document.body, {childList: true, subtree: true, characterData: true});
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, {once: true}) : boot();
})();
